import { BaseRequestQueryParam, HttpResponse, Streamer } from 'models';
import axiosClient, { handleRequest } from './axiosClient';
import { RewardSettingResponse, StreamResponse } from 'models/stream';
import { getLocalStorage } from 'utils/sessionStorage';

const streamApi = {
  getStreams: (): Promise<HttpResponse<StreamResponse[]>> => {
    const url = `/chat/api/common/streaming`;
    return handleRequest(axiosClient.get(url));
  },
  getRewardSetting: (): Promise<HttpResponse<RewardSettingResponse>> => {
    const url = `/chat/api/streaming/reward`;
    return handleRequest(
      axiosClient.get(url, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  reward: () => {
    const url = `/chat/api/streaming/reward`;
    return handleRequest(
      axiosClient.post(url, null, {
        headers: { Authorization: `Bearer ${getLocalStorage('access_token_terabet')}` },
      }),
    );
  },
  getStreamers : (params?: BaseRequestQueryParam) =>{
    const url  =`/chat/api/common/streaming/streamer`
    return handleRequest(axiosClient.get(url, { params }));
  },

  getStreamerById:(streamerId:string): Promise<HttpResponse<Streamer>> => {
    const url = `/chat/api/common/streaming/streamer/${streamerId}`
    return handleRequest(axiosClient.get(url));
  }

};

export default streamApi;
